<template>
  <p class="inline-block">
    <span
      v-for="(segment, index) in block.content"
      :key="index"
      :class="getFormattingClasses(segment.formatting)"
    >
      <RevLink
        v-if="segment.link"
        :target="segment.link.target || '_blank'"
        :to="segment.link.url"
      >
        {{ segment.text }}
      </RevLink>
      <template v-else>
        {{ segment.text }}
      </template>
    </span>
  </p>
</template>

<script setup lang="ts">
import type { TextBlock } from '@backmarket/catalog-shared-artifacts'
import { RevLink } from '@ds/components/Link'
import { tw } from '@ds/utils/tailwind'

defineProps<{
  block: TextBlock
}>()

const getFormattingClasses = (formatting?: {
  bold?: boolean
  italic?: boolean
}) => {
  if (!formatting) return ''

  const classes = []
  if (formatting.bold) classes.push(tw`font-weight-body-1-bold`)
  if (formatting.italic) classes.push(tw`font-body-1-italic`)

  return classes.join(' ')
}
</script>
